import { useMemo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'
import useSelectedPhoto from 'photo-module/photo/core/useSelectedPhoto'
import BackButton from 'photo-module/photo/ui/photo-viewer/actions-bar/BackButton'
import downloadStatus from 'photo-module/download/downloadStatus'
import videoState from 'video-module/video-clip/core/videoState'
import VideoPreviewViewer from '../../../../video-module/preview/VideoPreviewViewer'
import H265VideoPlayerContainer from '../../../../video-module/player/H265VideoPlayerContainer'
import NavigationActions from './NavigationActions'

const useStyles = makeStyles(theme => ({
  photoViewer: {
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'flex',
    backgroundColor: '#000',
    zIndex: theme.zIndex.modal + 1,
  },
  viewerContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    paddingBottom: '80px',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '6px',
      marginTop: '30px',
    },
  },
  mediaWrapper: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  photoWrapper: {
    cursor: 'zoom-in',
  },
  videoWrapper: {
    cursor: 'default',
  },
  photo: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
  navigationButtons: {
    position: 'absolute',
    bottom: theme.spacing(2),
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 'calc(100% - 80px)',
    maxWidth: '1200px',
    zIndex: theme.zIndex.modal + 1,
    [theme.breakpoints.down('sm')]: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      transform: 'none',
      width: '100%',
      maxWidth: 'none',
      padding: theme.spacing(1),
    },
  },
  backActionContainer: {
    position: 'absolute',
    top: theme.spacing(2.5),
    left: theme.spacing(2.5),
    zIndex: 999,
    [theme.breakpoints.down('sm')]: {
      top: 0,
      left: theme.spacing(0.7),
    },
  },
}))

const SpypointPhotoViewerContainer = () => {
  const classes = useStyles()
  const photo = useSelectedPhoto()
  const history = useHistory()

  const handleMediaClick = () => {
    if (photo && !videoState.isAVideo(photo) && !photo?.urls?.preview?.length) {
      history.push(`/camera/${photo.cameraId}/photo/${photo.id}`)
    }
  }

  const renderViewer = useMemo(() => {
    if (!photo) return null

    if (videoState.isAVideo(photo)) {
      return (
        <H265VideoPlayerContainer photo={photo} />
      )
    }

    if (photo?.urls?.preview?.length > 0) {
      return (
        <VideoPreviewViewer photo={photo} />
      )
    }

    const imageSrc = photo.hdStatus === downloadStatus.available
      ? photo.urls.hd
      : photo.urls.large

    return (
      <div className={`${classes.mediaWrapper} ${classes.photoWrapper}`} onClick={handleMediaClick} data-testid="photo-wrapper">
        <img
          className={classes.photo}
          src={imageSrc}
          alt={`Photo ${photo.id || ''}`}
        />
      </div>
    )
  }, [photo, classes.photo, classes.mediaWrapper])

  if (!photo) {
    return null
  }

  return (
    <div className={classes.photoViewer} data-testid="spypoint-photo-viewer-container">
      <div className={classes.backActionContainer} data-testid="back-action-container">
        <BackButton />
      </div>
      <div className={classes.viewerContainer} data-testid="viewer-container">
        { renderViewer }
      </div>
      <div className={classes.navigationButtons} data-testid="navigation-buttons">
        <NavigationActions />
      </div>
    </div>
  )
}

export default SpypointPhotoViewerContainer
